import React, { Fragment } from 'react'
import { Link, } from 'react-router-dom'
import './style.css'
export default function ResourcesCollectCard(props) {
    const { data } = props;
    return (
        <div className='ResourcesCollectCard' style={{ background: `radial-gradient(50% 50% at 50% 50%, rgba(83, 169, 255, 0.6) 0%, rgba(6, 17, 120, 0.6) 100%), url(${data.address}), 100% 100%,no-repeat,fixed` }}>
            {/* <img className='ResourcesCollectCard_BackgroundImg' src={data.address} /> */}
            <Link to={{ pathname: data.location, state: { index: data.index } }}>
                <div className='ResourcesCollectCard_Content'>
                    <img className='ResourcesCollectCard_ContentIcon' src={data.icon} />
                    <div className='ResourcesCollectCard_ContentTitle'>{data.title}</div>
                    <div className='ResourcesCollectCard_ContentBottom' />
                    <div className='ResourcesCollectCard_ContentIntroduce'>{data.introduce}</div>
                </div>
            </Link>
            <div className='ResourcesCollectCard_Label'>
                <TriangleLabel label={data.label} />
            </div>
        </div>
    )
}

const TriangleLabel = (props) => {
    return (
        <div className='TriangleLabel'>
            <div className='TriangleLabelMain'>
                <div className='TriangleLabel_Point' style={{ color: props.pointColor }} />
                <div className='TriangleLabel_Label'>{props.label}</div>
            </div>
            {/* <div className='TriangleLabel_Area' /> */}
        </div>
    )
}